import RoomTemplates from './RoomTemplates'

export default RoomTemplates
